import { LoginPage as DesignSystemLoginPage } from "@arcadeai/design-system/components/ui/pages/login-page";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "sonner";
import { authClient, sessionQueryOptions } from "@/lib/auth-client";
import { ACCOUNT_UI_URL } from "@/lib/const";
import { queryClient } from "@/lib/query-client";

export const Route = createFileRoute("/login")({
  beforeLoad: async () => {
    const session = await queryClient.fetchQuery({
      ...sessionQueryOptions,
      staleTime: 0,
    });
    if (session) {
      throw redirect({ to: "/" });
    }
  },
  component: LoginPage,
});

function LoginPage() {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const { error } = await authClient.signIn.oauth2({
        providerId: "oidc",
        callbackURL: new URL("/", window.location.origin).toString(),
      });
      if (error) {
        toast.error("Sign-in failed. Please try again.");
        setIsLoading(false);
      }
    } catch {
      toast.error("Sign-in failed. Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <DesignSystemLoginPage
      isLoading={isLoading}
      onSubmit={handleSubmit}
      registerHref={`${ACCOUNT_UI_URL}/registerOrRedirect`}
    />
  );
}
